import { PhosphorCaretLeftAnchor, PhosphorCaretRightAnchor } from "components/Atoms/PhosphorIconAnchor";
import OptionsPanel from "components/panels/OptionsPanel";
import React from "react";
import { DeleteDialog } from "../../../components";
import { getDocumentCoreApiExceptInvoice } from "../../../utilities/apiUtils";
import { changeLifecycle } from "../../../utilities/esigningUtils";
import DiscardModal from "../modals/DiscardModal";
import ManualCompleteModal from "../modals/ManualCompleteModal";
import StartNewVersionModal from "../modals/StartNewVersionModal";
import ShortcutsApp from "components/Shortcuts/app";

interface Props {
  optionsPanel: server.dto.OptionsPanelDataV2
  listUrl: string
  documentDetails: server.dto.ESignDocument
  copyUrl: string
}

const ESignOptionsPanel = (props: Props) => {
  const {
    optionsPanel,
    documentDetails
  } = props;

  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isDiscarding, setIsDiscarding] = React.useState(false);
  const [isStartingNewVersion, setIsStartingNewVersion] = React.useState(false);
  const [isManualCompleting, setIsManualCompleting] = React.useState(false);

  const lifeCycle = documentDetails.lifeCycle.value;

  const canCopy = site.permissions.contract.canCreate && site.currentEnvironment.invoice.hasV1;
  const canBeDeleted = documentDetails.permissions.canDelete
  const canBeDiscarded = documentDetails.permissions.canDiscard && !canBeDeleted && lifeCycle !== "discarded"

  const canStartNewVersion = lifeCycle === "pending";

  const canBeManuallyCompleted = lifeCycle === "pending";

  const onDelete = async () => {
    const documentApi = getDocumentCoreApiExceptInvoice(documentDetails.documentType);
    const outcome = await documentApi.Delete({ documentId: documentDetails.documentId });

    if (outcome.data.hasErrors) {
      window.displayGenericModal(RESX.ExceptionMessage.ThereIsAProblem, outcome.data.errors[0].message, "tiny", "red");
    } else {
      window.location.href = props.listUrl;
    }
    setIsDeleting(false);
  };

  return <OptionsPanel title={RESX.OptionsPanel.Options}>
    <div className="flex-column gap-small">
      <div>
        <a href={props.listUrl} >
          {RESX.Buttons.ListView}
        </a>
      </div>

      {canCopy && <div>
        <a href={props.copyUrl}>{RESX.Buttons.btnCopy}</a>
      </div>}

      {canStartNewVersion && <div>
        <a onClick={() => { setIsStartingNewVersion(true); }}>
          {RESX.ESign.StartNewVersion}
        </a>
      </div>}

      {canBeManuallyCompleted && <div>
        <a onClick={() => { setIsManualCompleting(true); }}>
          {RESX.ESign.CompleteManually}
        </a>
      </div>}

      {canBeDeleted && <a onClick={() => { setIsDeleting(true); }}>
        {RESX.Buttons.btnDelete}
      </a>}

      {canBeDiscarded && <a onClick={() => { setIsDiscarding(true); }}>
        {RESX.Buttons.btnDiscard}
      </a>}
    </div>

    <div>
      <ShortcutsApp
        shortcutOrder={["viewer", "show", "note"]}
      />
    </div>

    <div className="margin-top-big flex justify-space-between">
      <PhosphorCaretLeftAnchor
        layout="in-square"
        href={optionsPanel.previousUrl} />
      <div>
        {optionsPanel.currentPosition} / {optionsPanel.recordCount}
      </div>
      <PhosphorCaretRightAnchor
        layout="in-square"
        href={optionsPanel.nextUrl} />
    </div>

    <ManualCompleteModal
      isOpen={isManualCompleting}
      onClose={() => { setIsManualCompleting(false); }}
      documentId={documentDetails.documentId}
    />

    <StartNewVersionModal
      isOpen={isStartingNewVersion}
      documentType="contract"
      changeLifecycle={changeLifecycle}
      onClose={() => { setIsStartingNewVersion(false); }}
      documentId={documentDetails.documentId}
    />

    <DeleteDialog
      isOpen={isDeleting}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setIsDeleting(false); }}
      onDelete={onDelete} />

    <DiscardModal
      isOpen={isDiscarding}
      onClose={() => { setIsDiscarding(false); }}
      documentId={documentDetails.documentId}
      lastOverviewUrl={props.listUrl}
    />
  </OptionsPanel >;
};

export default ESignOptionsPanel;